import { useState, useEffect } from 'react'
import Spinner from '../components/Spinner'
import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'
import moment from 'moment'
import { BASE_URL } from '../constants'

const PreAuthListUpdates = ({}) => {
  const [data, setData] = useState(null)
  const [error, SetError] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const checkPriorAuthUpdates = async () => {
    setIsLoading(true)
    return fetch(`${BASE_URL}/Marketing/GetAuthRequiredUpdateNotifications`, {
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        'content-type': 'application/json',
      },
    })
      .then(res => {
        if (!res.ok) {
          const error = new Error(res.statusText)
          throw error
        }
        return res.json()
      })
      .then(json => {
        return setData(json)
      })
      .catch(err => {
        SetError(err)
        if (err.json) {
          return err.json.then(json => {
            error.value.message = json.message
          })
        }
      })
      .then(() => {
        return setIsLoading(false)
      })
  }

  useEffect(() => {
    checkPriorAuthUpdates()
  }, [])

  const hasData = data && data?.length > 0

  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="videocallAtDesk.png"
                  alt="Healthcare provider on a video call"
                />
              </div>
              <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                <h1 className="text-3xl tracking-tight md:text-5xl text-darkBlue">
                  Prior Auth List Updates <br />{' '}
                  <span className="text-globeGreen">For Medical Services.</span>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
            <h2 className="py-8 text-2xl text-center text-blue-dark md:text-4xl md:py-10">
              Prior Authorization List Updates for Medical Services
            </h2>
            {isLoading ? (
              <div className="grid w-full place-items-center">
                <Spinner />
              </div>
            ) : hasData ? (
              <div>
                <table className="m-auto md:mb-8">
                  <thead className="table-border-body">
                    <tr className="text-left font-[sans-serif]">
                      <th className="w-1/6 pl-4 text-sm h-14 md:text-base text-blue">
                        Notification Date
                      </th>
                      <th className="w-1/6 pl-4 text-sm h-14 md:text-base text-blue">
                        Procedure Code
                      </th>
                      <th className="w-1/4 pl-4 text-sm h-14 md:text-base text-blue">
                        Code Description
                      </th>
                      <th className="w-1/4 pl-4 text-sm h-14 md:text-base text-blue">
                        Update
                      </th>
                      <th className="w-1/6 pl-4 text-sm h-14 md:text-base text-blue">
                        Effective Date
                      </th>
                    </tr>
                  </thead>
                  <tbody className="blue-border-body text-grey">
                    {data?.map((item, index) => {
                      const isEven = index % 2 === 0
                      return (
                        <tr className="border-white border-y-2">
                          <td
                            className={`py-2 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 ${
                              isEven ? 'bg-sandWhite' : ''
                            }`}
                          >
                            <p className="text-sm">
                              {moment(item?.notification_date).format(
                                'MM/DD/YYYY'
                              )}
                            </p>
                          </td>
                          <td
                            className={`py-2 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 ${
                              isEven ? 'bg-sandWhite' : ''
                            }`}
                          >
                            <p className="text-sm">{item?.procedure_code}</p>
                          </td>
                          <td
                            className={`py-2 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 ${
                              isEven ? 'bg-sandWhite' : ''
                            }`}
                          >
                            <p className="text-sm">{item?.code_description}</p>
                          </td>
                          <td
                            className={`py-2 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 ${
                              isEven ? 'bg-sandWhite' : ''
                            }`}
                          >
                            <p className="text-sm">{item?.update}</p>
                          </td>
                          <td
                            className={`py-2 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 ${
                              isEven ? 'bg-sandWhite' : ''
                            }`}
                          >
                            <p className="text-sm">
                              {' '}
                              {moment(item?.effective_date).format(
                                'MM/DD/YYYY'
                              )}
                            </p>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>

                <ul className="mt-4 text-sm">
                  <li>
                    <b>Notification Date</b> is defined as the date the
                    information is placed on the insurer’s website.
                  </li>
                  <li>
                    <b>Procedure Code </b>is the service request code.
                  </li>
                  <li>
                    <b>Code Description</b> is the corresponding description to
                    the code.
                  </li>
                  <li>
                    <b>Update</b> in the prior authorization requirement.
                  </li>
                  <li>
                    <b>Effective Date</b> is defined as the date the prior
                    authorization update becomes effective. Eg Notification date
                    4/25/2024, with an effective date of 4/30/2024.
                  </li>
                </ul>
              </div>
            ) : (
              <div className="text-center">
                <p className="text-lg text-blue">
                  No updates available at this time.
                </p>
              </div>
            )}
          </div>
        </section>
      </Layout>
    </>
  )
}

export default PreAuthListUpdates
